import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 999,
		background: "linear-gradient(135deg, #001b3d 0%, #004e92 100%)",
		backdropFilter: "none",
	},
	paper: {
		padding: "24px 32px",
		width: "100%",
		maxWidth: 360,
		borderRadius: 16,
		backgroundColor: "#FFFFFF",
		boxShadow: "0 10px 40px rgba(0,0,0,0.12)",
		animation: "$fadeInUp 0.5s ease-out",
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 4,
	},
	title: {
		fontWeight: 800,
		color: "#0f172a",
		fontSize: "1.25rem",
	},
	subtitle: {
		color: "#94a3b8",
		fontSize: "0.9rem",
		marginBottom: 16,
	},
	progressContainer: {
		width: "100%",
		marginBottom: 16,
	},
	progressBar: {
		width: "100%",
		height: 6,
		backgroundColor: "#f1f5f9",
		borderRadius: 4,
		overflow: "hidden",
		marginBottom: 8,
		position: "relative",
	},
	progressFill: {
		width: "40%",
		height: "100%",
		backgroundColor: "#001b3d",
		borderRadius: 4,
		animation: "$progressAnim 2s infinite linear",
		position: "absolute",
	},
	footer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		paddingTop: 16,
		borderTop: "1px solid #f1f5f9",
		fontSize: "0.75rem",
		fontWeight: 600,
		color: "#94a3b8",
	},
	statusDot: {
		width: 8,
		height: 8,
		backgroundColor: "#001b3d",
		borderRadius: "50%",
		marginRight: 8,
	},
	"@keyframes fadeInUp": {
		from: { opacity: 0, transform: "translateY(20px)" },
		to: { opacity: 1, transform: "translateY(0)" },
	},
	"@keyframes progressAnim": {
		"0%": { left: "-40%" },
		"100%": { left: "100%" },
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	const [progress, setProgress] = React.useState(0);

	React.useEffect(() => {
		const timer = setInterval(() => {
			setProgress((prevProgress) => {
				if (prevProgress >= 95) {
					clearInterval(timer);
					return 95;
				}
				const diff = Math.random() * 15;
				return Math.min(prevProgress + diff, 95);
			});
		}, 200);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<Backdrop className={classes.backdrop} open={true}>
			<Paper className={classes.paper}>
				<Box className={classes.header}>
					<Typography className={classes.title}>Carregando</Typography>
					<CircularProgress size={32} thickness={5} style={{ color: "#001b3d" }} />
				</Box>
				<Typography className={classes.subtitle}>Aguarde alguns segundos...</Typography>

				<Box className={classes.progressContainer}>
					<div className={classes.progressBar}>
						<div className={classes.progressFill} style={{ width: `${progress}%`, animation: 'none', transition: 'width 0.4s ease-out' }} />
					</div>
					<Box display="flex" justifyContent="space-between">
						<Typography variant="caption" style={{ color: "#94a3b8", fontWeight: 600 }}>Processando</Typography>
						<Typography variant="caption" style={{ color: "#0f172a", fontWeight: 700 }}>{Math.round(progress)}%</Typography>
					</Box>
				</Box>

				<Box className={classes.footer}>
					<Box display="flex" alignItems="center">
						<div className={classes.statusDot} />
						Sistema online
					</Box>
					<Typography variant="caption" style={{ fontWeight: 600 }}>V.15.0.1</Typography>
				</Box>
			</Paper>
		</Backdrop>
	);
};

export default BackdropLoading;
